import { FormEvent, FunctionComponent, useState } from "react";
import Input from "../components/input/Input";
import Modal from "../components/modal/Modal";
import Button from "../components/button/Button";

const PortMappingModal: FunctionComponent<{
  issuerCode: string;
  onCancel: () => void;
  onSubmit: (formData: {
    issuerCode: string;
    port: number;
    ipAddress: string;
  }) => void;
}> = ({ issuerCode, onCancel, onSubmit }) => {
  const [formData, setFormData] = useState({
    issuerCode,
    port: 0,
    ipAddress: ""
  });

  const handleChange = (key: string, value: any) => {
    setFormData({ ...formData, [key]: value });
  };

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    onSubmit(formData);
  };

  return (
    <Modal cancel={onCancel} visible>
      <form onSubmit={handleSubmit}>
        <div className="input-group">
          <span className="question">Issuer Code</span>
          <Input
            value={formData.issuerCode}
            disabled
            onChange={value => handleChange("issuerCode", value)}
            placeholder="Enter additionalFields"
            responsive
          />
        </div>
        <div className="input-group">
          <span className="question">Port</span>
          <Input
            type="number"
            value={formData.port}
            onChange={value => handleChange("port", value)}
          />
        </div>
        <div className="input-group">
          <span className="question">IP Address</span>
          <Input
            value={formData.ipAddress}
            onChange={value => handleChange("ipAddress", value)}
          />
        </div>
        <div className="flex spaced end vertical-margin">
          <Button buttonType="button" onClick={onCancel}>
            Cancel
          </Button>
          <Button buttonType="submit">Create port mapping</Button>
        </div>
      </form>
    </Modal>
  );
};
export default PortMappingModal;
